import dynamic from 'next/dynamic';
import { NavbarLinkProps } from './props';
import { SettingLayoutComponentId } from '@starsoft/common/models';
import useMobileNavigationVariant from '@/hooks/theme/variants/useMobileNavigationVariant';

const NavbarLinkV1 = dynamic(() => import('./V1'), { ssr: true });
const NavbarLinkV2 = dynamic(() => import('./V2'), { ssr: true });

export default function NavbarLink({ ...props }: NavbarLinkProps) {
  const version: string = useMobileNavigationVariant();

  switch (version?.toString()) {
    case SettingLayoutComponentId.NavbarV1.toString():
      return <NavbarLinkV1 {...props} />;
    case SettingLayoutComponentId.NavbarV2.toString():
      return <NavbarLinkV2 {...props} />;
    default:
      return <NavbarLinkV2 {...props} />;
  }
}
